<template>
    <!-- wrapper div is here to apply class/style applications from parent -->
    <div class="d-flex align-center justify-center">
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <slot name="activator" :on="on" :attrs="attrs">
                    <v-progress-circular v-if="loading" indeterminate :size="iconSize" width="2" color="primary">
                    </v-progress-circular>
                    <v-icon v-else :size="iconSize" :color="iconColor" v-bind="attrs" v-on="on">
                        mdi-information
                    </v-icon>
                </slot>
            </template>

            <span v-html="markedText()" class="ma-0" />
        </v-tooltip>
    </div>
</template>


<script>
import { marked } from "marked";

export default {
    name: 'QInfo',
    props: {
        text: {
            type: String,
            default: ''
        },
        loading: {
            type: Boolean,
            default: false
        },
        iconSize: {
            type: Number,
            default: 18
        },
        iconColor: {
            type: String,
            default: ''
        }
    },
    components: {

    },

    data() {
        return {};
    },

    methods: {
        markedText() {
            return marked(this.text);
        }
    },

    computed: {},

    watch: {},
};
</script>


<style lang='scss' scoped></style>